/* @flow */

import type ApiService from 'services/ApiService';

export class ApiModel {
  api: ApiService;

  constructor(api: ApiService) {
    this.api = api;
  }
}
